document.addEventListener('DOMContentLoaded', function() {

  $('.custom_variant_auto').click(function(event){
      event.stopPropagation();
      var $list = $(this).next('.custom_variant_list');
      $('.custom_variant_list').not($list).hide();
      $list.toggle();
  });

  $(document).click(function(event) {
      if (!$(event.target).closest('.custom_variant_auto, .custom_variant_list').length) {
          $('.custom_variant_list').hide(); 
      }
  });

  function checkAndRun() {
      var isChecked1 = $('.custom_variant_list').eq(0).find('input[type="checkbox"]:checked').length > 0;
      var isChecked2 = $('.custom_variant_list').eq(1).find('input[type="checkbox"]:checked').length > 0;

    var checkedCount1 = $('.custom_variant_list').eq(0).find('input[type="checkbox"]:checked').length;
    var checkedCount2 = $('.custom_variant_list').eq(1).find('input[type="checkbox"]:checked').length;

    if (isChecked1){
      $('.custom_variant_auto.upper').text(`${checkedCount1} Items Selected`);
    }else{
      $('.custom_variant_auto.upper').text(`Choose an option`);
    }
    if (isChecked2){
      $('.custom_variant_auto.last').text(`${checkedCount2} Items Selected`);
    }else{
      $('.custom_variant_auto.last').text(`Choose an option`);
    }
    
    

      var addToCartButton = $('#add-to-cart-button');

       // Calculate total price
        var totalPrice = 0;
        $('.custom_variant_data__ input[type="checkbox"]:checked').each(function() {
            var price = parseInt($(this).data('multiple-price'), 10);
            totalPrice += price;
        });
        var formattedPrice = (totalPrice / 100).toFixed(2);
        
        // Update the UI for the total price
        $('.multiple-price').text("$" + formattedPrice);
    
      if (isChecked1 && isChecked2) {
          console.log("Both blocks have at least one checkbox checked!");
          addToCartButton.prop('disabled', false);
          $(addToCartButton).addClass('active');
      }else{
          console.log("Both blocks have not checked");
          addToCartButton.prop('disabled', true);
          $(addToCartButton).removeClass('active');
      }
  }

  
  $('.custom_variant_list input[type="checkbox"]').on('change', function() {
      checkAndRun(); 
  });

  $('#add-to-cart-button').click(function(e){
      e.preventDefault();
      
      var items = [];
      
      $('.custom_variant_list input[type="checkbox"]:checked').each(function() {
          if (this.id !== 'box_1_custom') {  
              var varId = $(this).val(); 
              var quantity = 1; 
              items.push({
                  id: varId,
                  quantity: quantity
              });
          }
      });
  
      var data = {
          items: items
      };
  
      $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          data: JSON.stringify(data), 
          contentType: "application/json; charset=utf-8", 
          success: function() {
              updateCartCounter()
              // window.location.href = '/cart';
          },
          error: function(xhr, status, error) {
              alert('Something went wrong: ' + error);
          }
      });
  });

  function updateCartCounter() {
    const newCount = Array.from(document.querySelectorAll('.custom_variant_list input[type="checkbox"]:checked'))
                           .filter(checkbox => checkbox.id !== 'box_1_custom')
                           .length;
    const cartCountElements = document.querySelectorAll('.cart_count');
    cartCountElements.forEach(cartCountElement => {
        cartCountElement.textContent = newCount;
    });
  }

  
  
  
  
    // const form = document.getElementById('add-multiple-variants-form');
    // const variant1Select = form.querySelector('[name="variant1-id"]');
    // const variant2Select = form.querySelector('[name="variant2-id"]');
    // const addToCartButton = document.getElementById('add-to-cart-button');
    // const buttonPrice = addToCartButton.querySelector('.multiple-price');
    // const defaultPrice = parseFloat(form.dataset.defaultPrice);

    // tooltipInit();
  
    // function updateButtonState(event) {
    //   const variant1Price = parseFloat(variant1Select.selectedOptions[0]?.dataset.multiplePrice || 0);
    //   const variant2Price = parseFloat(variant2Select.selectedOptions[0]?.dataset.multiplePrice || 0);
    //   const totalPrice = variant1Price + variant2Price;
  
    //   if (!variant1Select.selectedOptions[0]?.dataset.unavailable && 
    //       !variant2Select.selectedOptions[0]?.dataset.unavailable &&
    //       variant1Select.value && 
    //       (variant2Select.value || (variant2Select.selectedOptions[0]?.dataset.enableBtn))
    //     ) {
    //     addToCartButton.disabled = false;
    //     addToCartButton.classList.add('active');
    //     buttonPrice.textContent = `$${(totalPrice / 100).toFixed(2)}`;
    //   } else {
    //     addToCartButton.disabled = true;
    //     addToCartButton.classList.remove('active');
    //     buttonPrice.textContent = `$${(defaultPrice / 100).toFixed(2)}`;
    //   }

    //   const changedSelect = event.target;
    //   if(variant1Select.selectedOptions[0]?.dataset.unavailable) variant1Select.setAttribute("data-unavailable",true)
    //     else variant1Select.removeAttribute("data-unavailable")
    //   if(variant2Select.selectedOptions[0]?.dataset.unavailable) variant2Select.setAttribute("data-unavailable",true)
    //     else variant2Select.removeAttribute("data-unavailable")
    //   if(changedSelect.value) {
    //     const originalSelect = document.querySelector('.single-option-selector');
    //     originalSelect.value = changedSelect.options[changedSelect.selectedIndex].dataset.variantTitle;
    //     const newEvent = new Event('change');
    //     originalSelect.dispatchEvent(newEvent);
    //   }
    // }
  
    // function updateCartCounter() {
    //   const currentCount = parseInt(document.querySelector('.icon-cart .cart_count').innerHTML);
    //   const newCount = currentCount + 1;
    //   const cartCountElements = document.querySelectorAll('.cart_count');
    //   cartCountElements.forEach(function(cartCountElement) {
    //     cartCountElement.textContent = newCount;
    //   });
    // }
  
    // function animateAddToCart() {
    //     const checkmarkElement = addToCartButton.querySelector('.checkmark');
    //     if (checkmarkElement) {
    //         checkmarkElement.classList.add('checkmark-active');
    //     }
        
    //     window.setTimeout(() => {
    //         addToCartButton.removeAttribute('disabled');
    //         addToCartButton.classList.remove('disabled');
        
    //         if (checkmarkElement) {
    //             checkmarkElement.classList.remove('checkmark-active');
    //         }
        
    //         let spanElement = addToCartButton.querySelector('span');
    //         if (spanElement) {
    //             spanElement.classList.remove('zoomOut');
    //             spanElement.classList.add('fadeInDown');
    //         }
    //     }, 1000);
    // }

    // function showErrorMsj() {
    //     document.querySelectorAll('.warning').forEach(function(element) {
    //         element.remove();
    //     });
    //     const warning = document.createElement('p');
    //     warning.className = 'warning animated bounceIn';
    //     warning.innerHTML = error.replace('All 1 ', 'All ');
        
    //     form.insertAdjacentElement('afterend', warning);
        
    //     addToCartButton.removeAttribute('disabled');
    //     addToCartButton.classList.remove('disabled');
        
    //     const span = addToCartButton.querySelector('span');
    //     span.textContent = window.PXUTheme.translation.add_to_cart;
    //     span.classList.remove('zoomOut');
    //     span.classList.add('zoomIn');
    // }

    // function tooltipInit() {
    //   const tooltipElements = document.querySelectorAll('.cta-text[data-tooltip]');
    //   tooltipElements.forEach(element => {
    //     element.addEventListener('click', function(event) {
    //       tooltipElements.forEach(el => {
    //         if (el !== element) {
    //           el.classList.remove('active');
    //         }
    //       });

    //       element.classList.toggle('active');
    //       event.stopPropagation();
    //     });
    //   });

    //   document.addEventListener('click', function() {
    //     tooltipElements.forEach(element => {
    //       element.classList.remove('active');
    //     });
    //   });

    //   tooltipElements.forEach(element => {
    //     element.addEventListener('click', function(event) {
    //       event.stopPropagation();
    //     });
    //   });
    // }
  
    // variant1Select.addEventListener('change', updateButtonState);
    // variant2Select.addEventListener('change', updateButtonState);
  
    // form.addEventListener('submit', function(event) {
    //   event.preventDefault();
  
    //   const variant1Id = variant1Select.value;
    //   const variant2Id = variant2Select.value;
  
    //   function addVariantToCart(variantData, callback) {
    //     addToCartButton.setAttribute('disabled', 'disabled');
    //     addToCartButton.classList.add('disabled');

    //     let spanElement = addToCartButton.querySelector('span');
    //     spanElement.classList.remove('fadeInDown');
    //     spanElement.classList.add('animated', 'zoomOut');

    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //       },
    //       body: JSON.stringify(variantData)
    //     })
    //     .then(response => response.json())
    //     .then(data => {
    //       if (callback) callback();
    //       updateCartCounter();
    //       animateAddToCart();
    //     })
    //     .catch(error => {
    //         showErrorMsj(error)
    //     });
    //   }
  
    //   const variant1Data = variant1Id ? { id: variant1Id, quantity: 1 } : null;
    //   const variant2Data = variant2Id ? { id: variant2Id, quantity: 1 } : null;
  
    //   if (variant1Data) {
    //     addVariantToCart(variant1Data, function() {
    //       if (variant2Data) {
    //         addVariantToCart(variant2Data);
    //       }
    //     });
    //   } else if (variant2Data) {
    //     addVariantToCart(variant2Data);
    //   }
    // });

    
});





 